<template>
  <div class="items-center justify-between dark:bg-dark-600 bg-primary-10">
    <ul class="w-full h-full flex flex-col">
      <li>
        <SideMenuButton
          :icon="'code'"
          :isDisabled="rightSideFrame == 'Editor'"
          :text="$t('message.editor')"
          @click="setRightSideFrame('Editor')"
        />
      </li>
      <li>
        <SideMenuButton
          id="judge"
          :icon="'assessment'"
          :isDisabled="rightSideFrame == 'JudgeDetail'"
          :text="$t('message.judgeDetail')"
          @click="setRightSideFrame('JudgeDetail')"
        />
      </li>
      <li v-if="isLogin">
        <SideMenuButton
          :icon="'rate_review'"
          :isDisabled="rightSideFrame == 'ReviewPost'"
          :text="$t('message.submitReview')"
          @click="setRightSideFrame('ReviewPost')"
        />
      </li>
      <li>
        <SideMenuButton
          :icon="'view_list'"
          :isDisabled="rightSideFrame == 'JudgeQueue'"
          :text="$t('message.recentSubmissions')"
          @click="setRightSideFrame('JudgeQueue')"
        />
      </li>
      <li
        v-if="
          arenaPresenter.arenaId.value != '' &&
          arenaPresenter.arenaProblemIndex.value + 1 < arenaPresenter.arenaProblemElementList.value.length
        "
        class="mt-auto"
      >
        <SideMenuButton
          :icon="'arrow_forward'"
          :text="$t('message.nextProblem')"
          @click="() => setNextArenaProblem()"
        />
      </li>
      <li
        v-else-if="arenaPresenter.arenaId.value == '' && problemStatePresenter.nextProblemId.value != '-1'"
        class="mt-auto"
      >
        <SideMenuButton
          :icon="'arrow_forward'"
          :text="$t('message.nextProblem')"
          @click="() => problemStatePresenter.setProblemId(problemStatePresenter.nextProblemId.value)"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import SideMenuButton from './children/SideMenuButton.vue'

import { useArenaPresenter } from '@/presentation/composables/arena/useArenaPresenter'
import { useAuthStatePresenter } from '@/presentation/composables/auth/useAuthStatePresenter'
import { useFrameStatePresenter } from '@/presentation/composables/frame/useFrameStatePresenter'
import { useProblemStatePresenter } from '@/presentation/composables/problem/useProblemStatePresenter'

export default defineComponent({
  components: {
    SideMenuButton
  },
  setup(props, ctx) {
    const { isLogin } = useAuthStatePresenter()
    const problemStatePresenter = useProblemStatePresenter()
    const { rightSideFrame, setRightSideFrame } = useFrameStatePresenter()
    const arenaPresenter = useArenaPresenter()

    const setNextArenaProblem = () => {
      const nextIndex = arenaPresenter.arenaProblemIndex.value + 1
      if (nextIndex >= arenaPresenter.arenaProblemElementList.value.length) return
      arenaPresenter.setArenaProblem(
        arenaPresenter.arenaProblemElementList.value[nextIndex].problemId,
        arenaPresenter.arenaId.value,
        arenaPresenter.arenaProblemElementList.value[nextIndex].id,
        nextIndex
      )
    }

    return {
      isLogin,
      rightSideFrame,
      setRightSideFrame,
      setNextArenaProblem,
      problemStatePresenter,
      arenaPresenter
    }
  }
})
</script>

<style lang="postcss" scoped>
.hover-menu {
  text-decoration: none;

  &:hover {
    @apply relative;

    &::before {
      content: '';
      left: -12px;
      border-bottom: 8px solid transparent;
      border-top: 8px solid transparent;
      border-left: 8px solid #232a3b;
      @apply block absolute;
    }

    &::after {
      font-family: sans-serif;
      content: attr(data-tooltip);
      right: 130%;
      @apply bg-aoj text-white rounded p-2 block absolute font-bold text-base pointer-events-none z-10;
    }
  }
}

.hover-menu-dark {
  text-decoration: none;

  &:hover {
    @apply relative;

    &::before {
      content: '';
      left: -12px;
      border-bottom: 8px solid transparent;
      border-top: 8px solid transparent;
      border-left: 8px solid white;
      @apply block absolute;
    }

    &::after {
      font-family: sans-serif;
      content: attr(data-tooltip);
      right: 130%;
      @apply bg-black border text-dark-text rounded p-2 block absolute font-bold text-base pointer-events-none z-10;
    }
  }
}
.click-forward {
  &:active {
    @apply text-aoj-click;
  }
  &:focus {
    @apply outline-none;
  }
}

.click-forward-dark {
  &:active {
    @apply text-dark-100;
  }
  &:focus {
    @apply outline-none;
  }
}
.select {
  user-select: none;
}
</style>
